import React from 'react';
import { AlertTriangleIcon, BoxIcon, ClockIcon, TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { formatPrice } from '../../utils/format';
const STATS = [{
  label: 'Ventas hoy',
  value: formatPrice(48320),
  trend: '+12,4 %',
  up: true,
  hint: 'vs. ayer',
  icon: TrendingUpIcon,
  accent: 'text-teal-500'
}, {
  label: 'Pedidos pendientes',
  value: '2',
  badge: 'Requieren acción',
  hint: 'Más antiguo: hace 3 h',
  icon: ClockIcon,
  accent: 'text-pink-500'
}, {
  label: 'Productos activos',
  value: '12',
  trend: '+2',
  up: true,
  hint: 'este mes',
  icon: BoxIcon,
  accent: 'text-white/60'
}, {
  label: 'Stock bajo',
  value: '3',
  badge: 'Reponer',
  hint: 'Grips, Guantes, Kit Glute',
  icon: AlertTriangleIcon,
  accent: 'text-red-500',
  danger: true
}];
export function StatsCards() {
  return <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4" data-id="element-581" data-mp="1w0pc5wopecq7">
      {STATS.map(stat => {
      const Icon = stat.icon;
      return <article key={stat.label} className={`border bg-ink-700 p-5 ${stat.danger ? 'border-red-500/40' : 'border-white/8'}`} data-id="element-582" data-mp="22vcmqperbxrt">
            <div className="flex items-start justify-between gap-3" data-id="element-583" data-mp="2bw15fxf3imb1">
              <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/45" data-id="element-584" data-mp="2gucew71hausq">
                {stat.label}
              </p>
              <Icon className={`h-4 w-4 shrink-0 ${stat.accent}`} data-id="element-585" data-mp="2ptfwf6kzz254" />
            </div>
            <p className={`mt-4 font-display text-4xl leading-none ${stat.danger ? 'text-red-500' : 'text-white'}`} data-id="element-586" data-mp="2pr3728cwtpi1">
              {stat.value}
            </p>
            <div className="mt-3 flex items-center gap-2" data-id="element-587" data-mp="34iluusc0goby">
              {stat.trend && <span className={`flex items-center gap-1 text-xs font-semibold ${stat.up ? 'text-teal-500' : 'text-red-400'}`} data-id="element-588" data-mp="39hgcvs25m8v0">
                  {stat.up ? <TrendingUpIcon className="h-3.5 w-3.5" data-id="element-589" data-mp="2ev9cc4314j34" /> : <TrendingDownIcon className="h-3.5 w-3.5" data-id="element-590" data-mp="2tjclfmcdcaw5" />}
                  {stat.trend}
                </span>}
              {stat.badge && <span className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] ${stat.danger ? 'bg-red-500/15 text-red-400' : 'bg-pink-500/15 text-pink-400'}`} data-id="element-591" data-mp="32jivey8uysqk">
                  {stat.badge}
                </span>}
              <span className="truncate text-xs text-white/35" data-id="element-592" data-mp="37gss8yyku6of">{stat.hint}</span>
            </div>
          </article>;
    })}
    </div>;
}